import clsx from "clsx";
import { CSSProperties } from "react";
import { Dropdown } from "react-bootstrap";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import { useNavigate } from "react-router";
import { Icon, RenderWhen } from "../../../../../components";
import { LOCATION } from "../../../../search/consts";
import { SECTIONS } from "../../../consts";
import { useLocalSampleSummaryParams } from "../../../hooks";
import { getSearchPivotLink, pathToSS } from "../../../util";
import styles from "./file-similarity.module.scss";

type Item = {
  id: string;
  label: string;
  query: string;
};

type Props = {
  className?: string;
  menuStyle?: CSSProperties;
  label: string;
  items: Array<Item>;
  hasRha?: boolean;
};

const FileSimilarityFilter = ({
  hasRha,
  className,
  menuStyle,
  items,
  label
}: Props) => {
  const { hash, sourceId } = useLocalSampleSummaryParams();
  const navigate = useNavigate();

  const goToRHAPage = () => {
    const path = pathToSS(hash, sourceId, SECTIONS.THREAT_INTELLIGENCE.RHA);
    navigate(path);
  };

  return (
    <Dropdown id={styles.dropdown} className={clsx("primary", className)}>
      <Dropdown.Toggle
        id={`rha-to-search-filters`}
        data-testid="rha_to_search_filters"
        variant="link"
      >
        {label}{" "}
        <Icon name="chevron-down" className="dropdown-toggle__chevron-icon" />
      </Dropdown.Toggle>
      <Dropdown.Menu
        renderOnMount
        data-testid="rha_to_search_filters_menu"
        style={menuStyle}
      >
        <RenderWhen condition={Boolean(hasRha)}>
          <DropdownItem
            onClick={goToRHAPage}
            data-testid="rha_to_search_filter_item_similar_by_rha_hash_similarity"
          >
            Similar by RHA Hash (by similarity)
          </DropdownItem>
        </RenderWhen>
        {items.map(item => (
          <Dropdown.Item
            key={item.label}
            href={getSearchPivotLink(item.query, {}, false, LOCATION.CLOUD)}
            target="_blank"
            data-testid={`rha_to_search_filter_item_${item.id}`}
          >
            {item.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default FileSimilarityFilter;
